module.exports = __webpack_public_path__ + "static/img/develop.7ca1710.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/develop.svg
// module id = ifSP
// module chunks = 30